module.exports = __webpack_public_path__ + "img/ajuda-card-03.79e02e95.jpg";